export default function attr(type) {
  return function (target, key) {
    let _type = type;
    if (!target.constructor.attributes) {
      target.constructor.attributes = {};
    }

    target.constructor.attributes[key] = _type;
  };
}
